import { render, staticRenderFns } from "./RestorePasswordForm.vue?vue&type=template&id=ef32d5ba&"
import script from "./RestorePasswordForm.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports